import { queryParams } from "../types/global";

export const getQueryString = (
  url: string,
  defaultValues = {}
): queryParams => {
  const queryString = (/\?(.*?)(?:#|$)/.exec(url) || [undefined, ""])[1];

  const query = queryString.split("&").reduce((acc, curr) => {
    const [k, v] = curr.split("=");
    if (!k || !v) {
      return acc;
    }

    const key = decodeURIComponent(k);
    const value = decodeURIComponent(v.replace(/\+/g, " "));
    const parsedValue = /^\d*$/.test(value) ? parseInt(value) : value;

    return { ...acc, [key]: parsedValue };
  }, defaultValues);

  return query;
};
